import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=7ead5022&scoped=true&"
import script from "./button.ts?vue&type=script&lang=ts&"
export * from "./button.ts?vue&type=script&lang=ts&"
import style0 from "./Button.vue?vue&type=style&index=0&id=7ead5022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ead5022",
  null
  
)

export default component.exports